export const SIZE_SCHEMA_STORAGE_KEY = "ot-preferred-size-schema";
